import { makeStyles } from '@material-ui/core';
import { komaxColors } from '../../theme/komax';

// Komax wordmark from the corporate PowerPoint master, recoloured for the dark
// sidebar: letters in white, the right stroke of the "x" stays Komax red.
const LETTERS = [
  'M2331 1376 2331 1417 2337.63 1417 2337.63 1403.73 2337.78 1403.73 2348.33 1417 2357 1417 2344.94 1402.69 2356.25 1390.82 2347.81 1390.82 2337.63 1401.81 2337.63 1376 2331 1376Z',
  'M2361.48 1403.91C2361.48 1399.75 2364.27 1395.96 2369 1395.96 2373.73 1395.96 2376.52 1399.75 2376.52 1403.91 2376.52 1408.06 2373.73 1411.86 2369 1411.86 2364.27 1411.86 2361.48 1408.06 2361.48 1403.91M2355 1403.91C2355 1412.4 2361.12 1418 2369 1418 2376.88 1418 2383 1412.4 2383 1403.91 2383 1395.6 2376.88 1390 2369 1390 2361.12 1390 2355 1395.6 2355 1403.91',
  'M2386 1390.54C2392.27 1390.54 2392.27 1390.54 2392.27 1390.54 2392.27 1394.65 2392.27 1394.65 2392.27 1394.65 2392.45 1394.65 2392.45 1394.65 2392.45 1394.65 2393.52 1392.32 2396.21 1390 2400.5 1390 2404.62 1390 2407.48 1391.61 2408.74 1394.83 2410.71 1391.43 2413.57 1390 2417.51 1390 2424.49 1390 2427 1395.01 2427 1401.26 2427 1417 2427 1417 2427 1417 2420.38 1417 2420.38 1417 2420.38 1417 2420.38 1401.98 2420.38 1401.98 2420.38 1401.98 2420.38 1398.76 2419.48 1395.9 2415.54 1395.9 2411.42 1395.9 2409.81 1399.3 2409.81 1402.7 2409.81 1417 2409.81 1417 2409.81 1417 2403.19 1417 2403.19 1417 2403.19 1417 2403.19 1401.26 2403.19 1401.26 2403.19 1401.26 2403.19 1398.05 2401.93 1395.9 2398.71 1395.9 2394.41 1395.9 2392.62 1399.12 2392.62 1402.52 2392.62 1417 2392.62 1417 2392.62 1417 2386 1417 2386 1417 2386 1417L2386 1390.54Z',
  'M2447.78 1406.8C2447.78 1410.59 2445.64 1412.94 2441.2 1412.94 2439.07 1412.94 2436.58 1411.86 2436.58 1409.51 2436.58 1405.54 2442.8 1405.35 2446.36 1405.35 2447.78 1405.35 2447.78 1405.35 2447.78 1405.35L2447.78 1406.8ZM2448.13 1417.28C2454 1417.28 2454 1417.28 2454 1417.28 2454 1401.92 2454 1401.92 2454 1401.92 2454 1398.13 2454 1390 2442.8 1390 2438.71 1390 2434.62 1391.26 2431.6 1394.15 2435.16 1397.77 2435.16 1397.77 2435.16 1397.77 2436.93 1395.96 2439.42 1394.88 2442.09 1394.88 2445.64 1394.88 2448.13 1396.68 2448.13 1399.94 2448.13 1400.66 2448.13 1400.66 2448.13 1400.66 2446.53 1400.66 2446.53 1400.66 2446.53 1400.66 2439.96 1400.66 2430 1401.2 2430 1409.87 2430 1415.29 2434.62 1418 2439.6 1418 2442.98 1418 2446 1416.55 2447.96 1413.66 2448.13 1413.66 2448.13 1413.66 2448.13 1413.66L2448.13 1417.28Z',
  'M2464.65 1403 2468 1397.7 2463.6 1391 2456 1391 2464.5 1403 2464.65 1403Z',
  'M2464.5 1404 2464.5 1404 2456 1417 2463.6 1417 2468 1409.89 2464.5 1404Z',
];
const X_RED =
  'M2482 1391 2474.3 1391 2466 1403.82 2474.3 1417 2482 1417 2472.89 1403.82 2482 1391Z';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="2331 1376 151 41"
      role="img"
      aria-label="Komax"
    >
      {LETTERS.map(d => (
        <path key={d} d={d} fill="#FFFFFF" fillRule="evenodd" />
      ))}
      <path d={X_RED} fill={komaxColors.red} fillRule="evenodd" />
    </svg>
  );
};

export default LogoFull;
